<template>
  <div>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>调动记录</i></p>
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">店员工号</div>
              <div class="itemNum">{{ form.staffNo }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请门店</div>
              <div class="itemNum">{{ form.applyShopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">调动类型</div>
              <div class="itemNum">{{ form.transferType == 'formal' ? "他店调入" : "临时帮忙" }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请时间</div>
              <div class="itemNum">{{ formatDate(form.applyTime) }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.yuanYuanGroupDirectFlag == 'no'">
              <div class="itemName">审核结果</div>
              <div class="itemNum">{{ form.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.yuanYuanGroupDirectFlag == 'no'">
              <div class="itemName">审核时间</div>
              <div class="itemNum">{{ formatDate(form.auditTime) }}</div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="!showAttendanceTip"><span class="blueBlock"></span><i>打卡异常</i></p>
          <div class="totals-box pl24 mt20" v-if="!showAttendanceTip">
            <div class="flex-row mb30">
              <el-col :span="20"> 该店员在本门店有打卡异常待处理</el-col>
              <el-col :span="4">
                <div class="jishi cur" @click="gotoAttendance">去处理</div>
              </el-col>
            </div>
          </div>
          <template v-if="form.yuanYuanGroupDirectFlag == 'yes'">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>审批流程</i></p>
            <div class="flex-row mlr24" v-for="item,index in form.flowAuditConfigList" :key="index">
              <div class="process-left">
                <div class="process-boxs">
                  <div class="process-img">
                    <img :src="item.headImgUrl" alt="" v-if="item.headImgUrl">
                    <img src="../../../assets/images/staffJounary_headerImg.png" alt="" v-else>
                    <div class="audit-img">
                      <img src="../../../assets/images/audit_success.png" alt="" v-if="item.auditStatus == 'pass'">
                      <img src="../../../assets/images/audit_wait.png" alt="" v-else-if="item.auditStatus == 'wait'">
                      <img src="../../../assets/images/audit_refuse.png" alt="" v-else-if="item.auditStatus == 'refuse'">
                    </div>
                  </div>
                  <div class="process-vertical" v-if="form.flowAuditConfigList.length - index != 1"></div>
                </div>
              </div>
              <div class="ml16 w100b process-right">
                <div class="align-items color999 f12">
                  <div>{{item.nodeName}}</div>
                  <div>{{formatDate(item.auditTime)}}</div>
                </div>
                <div class="mt5 f16 process-auditName" :class="[form.flowAuditConfigList.length - index != 1 ? 'mb40':'mb20']">
                  <div v-for="(it,ind) in item.operateStaffBOList" :key="it.staffId">
                    <span >{{it.staffName}}</span>
                    <span v-if="ind != item.operateStaffBOList.length - 1">,</span>
                  </div>
                  <span v-if="item.auditStatus">（{{item.auditStatusCn}}）</span>
                </div>
                <div class="process-refuse" v-if="item.auditStatus == 'refuse'">{{item.remark}}</div>
              </div>
            </div>
          </template>
        </div>
        <div class="drawer-footer pr24 pb10" v-perm="{key:'staffTransfer', value:'staffTransfer:audit'}">
          <el-button type="warning" v-if="form.refuseFlag" @click="calcel">拒绝</el-button>
          <el-button type="primary" v-if="form.agreeFlag" @click="addClick">同意</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "调动详情",
      addEditShow: false,
      form: {},
      month: '',
      dialogVisible: false,
      showAttendanceTip: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function (org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.companyStaffTransfer.get, {
          id: org.id
        }).then(res => {
          if (res) {
            this.form = res;
            if (res.auditStatus == 'wait') {
              this.getAttendaceFlag(this.form.staffId);
            } else {
              this.showAttendanceTip = true;
            }
          }
        });
      });
    },
    async confirm() {
      const res = await this.$api.post(this.$url.companyStaffTransfer.audit, { id: this.form.id, auditStatus: "pass" })
      if (res) {
        this.$message.success("操作成功")
        this.addEditShow = false;
        this.$emit("change", true);
      }
    },
    addClick() {
      if (!this.form.stopStaffStockFalg) {
        this.$confirm("确定要同意吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }).then(() => {
          this.confirm()
        })
      } else {
        this.$confirm("店员持股期间调至其它门店将自动终止持股，确定要同意吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }).then(() => {
          this.confirm()
        })
      }

    },
    calcel() {
      this.$confirm("确定要拒绝吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(() => {
        this.$api.post(this.$url.companyStaffTransfer.audit, { id: this.form.id, auditStatus: "refuse" }).then(res => {
          if (res) {
            this.$message.success("操作成功")
            this.addEditShow = false;
            this.$emit("change", true);
          }
        });
      }).catch(() => { });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    getAttendaceFlag(staffId) {
      this.$api.post('/merchant/app/multiData/attendance/listAbnormalByStaffId', { staffId: staffId }).then(res => {
        if (res) {
          if (res.length == 0) {
            this.showAttendanceTip = true;
          } else {
            this.showAttendanceTip = false;
            this.month = this.formatMonth(res[0].attendanceDate);
          }
        }
      });
    },
    gotoAttendance() {
      this.$router.push({
        path: "/dataList/attendanceDetail",
        query: {
          month: this.month,
          staffId: this.form.staffId
        }
      });
    }
  }
};
</script>
<style lang="less">
.process-boxs {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-img {
  width: 40px;
  height: 40px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.process-auditName {
  display: flex;
  flex-wrap: wrap;
}
.audit-img {
  width: 14px;
  height: 14px;
  position: absolute;
  right: 0;
  bottom: 0;
    img {
    width: 100%;
    height: 100%;
  }
}
.process-vertical {
  width: 2px;
  height: 32px;
  margin: 4px 0;
  background: #E6E6E6;
}
.process-right {
  .process-refuse {
    padding: 12px;
    margin-top: 8px;
    color: #666;
    background: #F2F1F6;
    border-radius: 4px;
  }
}
</style>